import { graphql } from "gatsby";

import { isCurrentInstance } from "../config";

const areTreatmentsAvailable = () => isCurrentInstance("CH");

const getRating = (result: { shopify: { title: string } | null }) => {
  switch (result?.shopify?.title) {
    case "Dentalhygiene":
      return { count: 235, value: 4.8 };
    case "Bleaching":
      return { count: 156, value: 4.7 };
    case "Zahnschmuck":
      return { count: 97, value: 4.7 };
    case "Oral Health Checkup":
      return { count: 97, value: 4.8 };
    default:
      return { count: 378, value: 4.8 };
  }
};

const getShopifyVariant = (
  variants: readonly Pick<
    Queries.ShopifyProductVariant,
    "availableForSale" | "title" | "shopifyId" | "price" | "compareAtPrice"
  >[],
  title: string | null,
) => {
  if (!title) return null;

  return variants.find((v) => v?.availableForSale && v.title === title) || null;
};

const getVariant = (
  result: Queries.PageTreatmentVariantsFragment | Queries.HiddenTreatmentVariantsFragment,
  index: number,
) => {
  const {
    data: { variants },
    shopify,
  } = result;
  const empty = { variant: null, shopifyVariant: null };

  if (!variants || !shopify) return empty;
  const variant = variants[index] ?? null;

  if (!variant) return empty;

  const shopifyVariant = getShopifyVariant(shopify.variants, variant.variant_shopify_title);

  return { variant, shopifyVariant };
};

const bookingLink = "https://booking.denteo.com/34eb2a3868ecc264a5458d4f069edaf7/locations/2";

export const query = graphql`
  fragment TreatmentRating on PrismicTreatment {
    shopify {
      title
      stamped {
        total
        rating
      }
    }
  }

  fragment HiddenTreatmentRating on PrismicHiddenTreatment {
    shopify {
      title
      stamped {
        total
        rating
      }
    }
  }

  fragment TreatmentVariants on PrismicAllDocumentTypes {
    ...PageTreatmentVariants
    ...HiddenTreatmentVariants
  }

  fragment PageTreatmentVariants on PrismicTreatment {
    data {
      variants {
        variant_duration
        variant_shopify_title
        variant_title
      }
    }
    shopify {
      shopifyId
      variants {
        availableForSale
        position
        shopifyId
        title
      }
    }
    ...TreatmentPrice
  }
  fragment HiddenTreatmentVariants on PrismicHiddenTreatment {
    data {
      variants {
        variant_duration
        variant_shopify_title
        variant_title
      }
    }
    shopify {
      shopifyId
      variants {
        availableForSale
        position
        shopifyId
        title
      }
      ...ShopifyPrice
      ...ShopifyCompareAtPrice
      ...ShopifyCurrency
    }
  }
`;

export { areTreatmentsAvailable, bookingLink, getRating, getShopifyVariant, getVariant };
